import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ICustomError } from '../interfaces/custom-error.interface';
import { AuthServices } from '../services/auth.services';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(private router: Router, private messageService: MessageService, private authServices: AuthServices) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      withCredentials: true,
    });

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        const status = err.status;
        const customError = <ICustomError>err.error;

        if (status === HttpStatusCode.Unauthorized || status === HttpStatusCode.Forbidden) {
          this.authServices._isAuthenticated = false;

          // Don't attempt refresh token for refresh token endpoint itself
          if (request.url.includes('/fusionauth/refreshToken') || request.url.includes('/fusionauth/getAuthenticatedUser')) {
            return throwError(() => err);
          }

          return this.handle401Error(request, next);
        }

        // Non mostrare messaggi per endpoint di autenticazione quando non autenticato
        if (request.url.includes('/fusionauth/refreshToken')) {
          return throwError(() => err);
        }

        if (customError?.message) {
          const isWarning = customError?.isWarning === true || (status === HttpStatusCode.BadRequest && !customError?.status);
          this.messageService.add({
            severity: isWarning ? 'warn' : 'error',
            summary: isWarning ? 'Attenzione' : 'Errore',
            detail: customError.message,
          });
        }

        return throwError(() => err);
      }),
    );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    return this.authServices.refreshWithLock().pipe(
      switchMap((ok) => {
        if (ok) {
          this.authServices._isAuthenticated = true;
          return next.handle(request);
        }

        // Only redirect to login if not already on login page
        if (!this.router.url.includes('/login') && !this.router.url.includes('/callback')) {
          this.router.navigate(['/login']);
        }

        return throwError(() => new Error('Unauthenticated'));
      }),
    );
  }
}
